import * as type from '../../../actions/index.types';

const initialState = {
    // society dropdown (scoped)
    societyDropdownLoading: false,
    societyDropdownData: null,

    // list (flat)
    listLoading: false,
    listData: null,
    pagination: null,

    // directory (grouped by person)
    directoryLoading: false,
    directoryData: null,
    directoryPagination: null,

    // stats dashboard
    statsLoading: false,
    statsData: null,

    // single employee
    detailsLoading: false,
    detailsData: null,

    // person's societies panel
    societiesLoading: false,
    societiesData: null,
    assignLoading: false,
    changeRoleLoading: false,

    // mutations
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    bulkLoading: false,

    // add-from-existing (search + link)
    searchedLoading: false,
    searchedData: null,
    searchedError: null,
    linkLoading: false,

    // employee-type dropdown
    typesDropdownLoading: false,
    typesDropdownData: null,

    // employee-types (roles) catalog
    rolesLoading: false,
    rolesData: null,
    rolesPagination: null,
    roleDetailsData: null,
    roleCreateLoading: false,
    roleUpdateLoading: false,
    roleDeleteLoading: false,

    error: null,
};

export function CtrlEmployeeReducer(state = initialState, action) {
    switch (action.type) {
        // ---- society dropdown ----
        case type.CTRL_SOCIETY_DROPDOWN:
            return { ...state, societyDropdownLoading: true };
        case type.CTRL_SOCIETY_DROPDOWN_SUCCESS:
            return {
                ...state,
                societyDropdownLoading: false,
                societyDropdownData: Array.isArray(action.payload) ? action.payload : (action.payload?.data || []),
            };
        case type.CTRL_SOCIETY_DROPDOWN_FAILURE:
            return { ...state, societyDropdownLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- list ----
        case type.CTRL_EMPLOYEE_LIST:
            return { ...state, listLoading: true, error: null };
        case type.CTRL_EMPLOYEE_LIST_SUCCESS: {
            const pg = action.payload?.pagination;
            const rows = action.payload?.rows;
            return {
                ...state,
                listLoading: false,
                listData: Array.isArray(rows) ? rows : [],
                pagination: pg || { total: (rows || []).length, page: 1, limit: 10, totalPages: 1 },
                error: null,
            };
        }
        case type.CTRL_EMPLOYEE_LIST_FAILURE:
            return { ...state, listLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- directory (grouped) ----
        case type.CTRL_EMPLOYEE_DIRECTORY:
            return { ...state, directoryLoading: true, error: null };
        case type.CTRL_EMPLOYEE_DIRECTORY_SUCCESS: {
            const pg = action.payload?.pagination;
            const rows = action.payload?.rows;
            return {
                ...state,
                directoryLoading: false,
                directoryData: Array.isArray(rows) ? rows : [],
                directoryPagination: pg || { total: (rows || []).length, page: 1, limit: 10, totalPages: 1 },
                error: null,
            };
        }
        case type.CTRL_EMPLOYEE_DIRECTORY_FAILURE:
            return { ...state, directoryLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- person societies panel ----
        case type.CTRL_EMPLOYEE_SOCIETIES:
            return { ...state, societiesLoading: true, error: null };
        case type.CTRL_EMPLOYEE_SOCIETIES_SUCCESS:
            return { ...state, societiesLoading: false, societiesData: action.payload || null };
        case type.CTRL_EMPLOYEE_SOCIETIES_FAILURE:
            return { ...state, societiesLoading: false, error: action?.message || 'Something went wrong.' };

        case type.CTRL_ASSIGN_EMPLOYEE_SOCIETY:
            return { ...state, assignLoading: true, error: null };
        case type.CTRL_ASSIGN_EMPLOYEE_SOCIETY_SUCCESS:
            return { ...state, assignLoading: false };
        case type.CTRL_ASSIGN_EMPLOYEE_SOCIETY_FAILURE:
            return { ...state, assignLoading: false, error: action?.message || 'Something went wrong.' };

        case type.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE:
            return { ...state, changeRoleLoading: true, error: null };
        case type.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_SUCCESS:
            // API returns the refreshed societies[]; keep the panel in sync.
            return {
                ...state,
                changeRoleLoading: false,
                societiesData: action.payload?.societies
                    ? { ...(state.societiesData || {}), societies: action.payload.societies }
                    : state.societiesData,
            };
        case type.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_FAILURE:
            return { ...state, changeRoleLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- stats ----
        case type.CTRL_EMPLOYEE_STATS:
            return { ...state, statsLoading: true };
        case type.CTRL_EMPLOYEE_STATS_SUCCESS:
            return { ...state, statsLoading: false, statsData: action.payload || null };
        case type.CTRL_EMPLOYEE_STATS_FAILURE:
            return { ...state, statsLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- details ----
        case type.CTRL_EMPLOYEE_DETAILS:
            return { ...state, detailsLoading: true, detailsData: null, error: null };
        case type.CTRL_EMPLOYEE_DETAILS_SUCCESS:
            return { ...state, detailsLoading: false, detailsData: action.payload };
        case type.CTRL_EMPLOYEE_DETAILS_FAILURE:
            return { ...state, detailsLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- create ----
        case type.CTRL_CREATE_EMPLOYEE:
            return { ...state, createLoading: true, error: null };
        case type.CTRL_CREATE_EMPLOYEE_SUCCESS:
            return { ...state, createLoading: false };
        case type.CTRL_CREATE_EMPLOYEE_FAILURE:
            return { ...state, createLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- update ----
        case type.CTRL_UPDATE_EMPLOYEE:
            return { ...state, updateLoading: true, error: null };
        case type.CTRL_UPDATE_EMPLOYEE_SUCCESS:
            return { ...state, updateLoading: false };
        case type.CTRL_UPDATE_EMPLOYEE_FAILURE:
            return { ...state, updateLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- delete ----
        case type.CTRL_DELETE_EMPLOYEE:
            return { ...state, deleteLoading: true, error: null };
        case type.CTRL_DELETE_EMPLOYEE_SUCCESS:
            return { ...state, deleteLoading: false };
        case type.CTRL_DELETE_EMPLOYEE_FAILURE:
            return { ...state, deleteLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- bulk status / reassign ----
        case type.CTRL_BULK_STATUS_EMPLOYEE:
        case type.CTRL_BULK_REASSIGN_EMPLOYEE:
            return { ...state, bulkLoading: true, error: null };
        case type.CTRL_BULK_STATUS_EMPLOYEE_SUCCESS:
        case type.CTRL_BULK_REASSIGN_EMPLOYEE_SUCCESS:
            return { ...state, bulkLoading: false };
        case type.CTRL_BULK_STATUS_EMPLOYEE_FAILURE:
        case type.CTRL_BULK_REASSIGN_EMPLOYEE_FAILURE:
            return { ...state, bulkLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- search by email ----
        case type.CTRL_SEARCH_EMPLOYEE_BY_EMAIL:
            return { ...state, searchedLoading: true, searchedData: null, searchedError: null };
        case type.CTRL_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS:
            return { ...state, searchedLoading: false, searchedData: action.payload || null, searchedError: null };
        case type.CTRL_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE:
            return { ...state, searchedLoading: false, searchedData: null, searchedError: action?.message || 'Employee not found' };
        case type.CTRL_CLEAR_EMPLOYEE_SEARCH:
            return { ...state, searchedLoading: false, searchedData: null, searchedError: null };

        // ---- link existing ----
        case type.CTRL_LINK_EXISTING_EMPLOYEE:
            return { ...state, linkLoading: true, error: null };
        case type.CTRL_LINK_EXISTING_EMPLOYEE_SUCCESS:
            return { ...state, linkLoading: false };
        case type.CTRL_LINK_EXISTING_EMPLOYEE_FAILURE:
            return { ...state, linkLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- employee-type dropdown ----
        case type.CTRL_EMPLOYEE_TYPES_DROPDOWN:
            return { ...state, typesDropdownLoading: true };
        case type.CTRL_EMPLOYEE_TYPES_DROPDOWN_SUCCESS:
            return {
                ...state,
                typesDropdownLoading: false,
                typesDropdownData: Array.isArray(action.payload) ? action.payload : (action.payload?.data || []),
            };
        case type.CTRL_EMPLOYEE_TYPES_DROPDOWN_FAILURE:
            return { ...state, typesDropdownLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- roles catalog: list ----
        case type.CTRL_EMPLOYEE_ROLE_LIST:
            return { ...state, rolesLoading: true, error: null };
        case type.CTRL_EMPLOYEE_ROLE_LIST_SUCCESS: {
            const pg = action.payload?.pagination;
            const rows = action.payload?.rows;
            return {
                ...state,
                rolesLoading: false,
                rolesData: Array.isArray(rows) ? rows : [],
                rolesPagination: pg || { total: (rows || []).length, page: 1, limit: 10, totalPages: 1 },
            };
        }
        case type.CTRL_EMPLOYEE_ROLE_LIST_FAILURE:
            return { ...state, rolesLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- roles catalog: details ----
        case type.CTRL_EMPLOYEE_ROLE_DETAILS:
            return { ...state, roleDetailsData: null };
        case type.CTRL_EMPLOYEE_ROLE_DETAILS_SUCCESS:
            return { ...state, roleDetailsData: action.payload };
        case type.CTRL_EMPLOYEE_ROLE_DETAILS_FAILURE:
            return { ...state, error: action?.message || 'Something went wrong.' };

        // ---- roles catalog: create ----
        case type.CTRL_CREATE_EMPLOYEE_ROLE:
            return { ...state, roleCreateLoading: true, error: null };
        case type.CTRL_CREATE_EMPLOYEE_ROLE_SUCCESS:
            return { ...state, roleCreateLoading: false };
        case type.CTRL_CREATE_EMPLOYEE_ROLE_FAILURE:
            return { ...state, roleCreateLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- roles catalog: update ----
        case type.CTRL_UPDATE_EMPLOYEE_ROLE:
            return { ...state, roleUpdateLoading: true, error: null };
        case type.CTRL_UPDATE_EMPLOYEE_ROLE_SUCCESS:
            return { ...state, roleUpdateLoading: false };
        case type.CTRL_UPDATE_EMPLOYEE_ROLE_FAILURE:
            return { ...state, roleUpdateLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- roles catalog: delete ----
        case type.CTRL_DELETE_EMPLOYEE_ROLE:
            return { ...state, roleDeleteLoading: true, error: null };
        case type.CTRL_DELETE_EMPLOYEE_ROLE_SUCCESS:
            return { ...state, roleDeleteLoading: false };
        case type.CTRL_DELETE_EMPLOYEE_ROLE_FAILURE:
            return { ...state, roleDeleteLoading: false, error: action?.message || 'Something went wrong.' };

        default:
            return state;
    }
}
